import React from 'react';
import Head from '../../layout/head.jsx'
import Content from '../../layout/content.jsx'
import Form from '../../layout/form.jsx'
import API from '../../../services/api.jsx'
import Loader from '../../layout/loader.jsx'
import { toast } from 'react-toastify'
import Helpers from "../../../services/helpers.jsx";

class DeviceEdit extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			loading: true,
			breadcrumb: { title: 'View device', path: '/clients/' + props.match.params.clientId + '/devices/' + props.match.params.deviceId },
			fields: {
				name: { label: 'Name', type: 'text', required: true },
				sku: { label: 'SKU', type: 'text', required: true },
				// type: { label: 'Device type', type: 'select', options: [{ key: 'pipo', label: 'PIPO' }, { key: 'indus', label: 'Industrial Tablet' }], required: true },
				manualModeEnable: { label: 'Authorize manual mode', type: 'boolean', required: true }
			},
			device: null 
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	componentDidMount() {
		API.getDevice(this.props.match.params.deviceId).then(device => this.setState({ loading: false, device: device }))
	}

	saveEntity(fields) {
		if (!Helpers.checkPermissions("devices:edit")) {
      toast.error("You do not have permission to save it");
      return;
    }

		this.setState({ loading: true })
		API.update('devices', this.props.match.params.deviceId, fields).then(() => {
			toast.success('Device has been updated')
			this.props.history.push('/clients/' + this.props.match.params.clientId + '/devices/' + this.props.match.params.deviceId)
		}).catch(() => {
			// toast.error('An unexpected error has occured, please try again')
			this.setState({ loading: false })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Edit device'} breadcrumb={this.state.breadcrumb} tabs={this.state.tabs} />
				<Content>
					<Form fields={this.state.fields} entity={this.state.device} cancel={() => this.props.history.push('/clients/' + this.props.match.params.clientId + '/devices/' + this.props.match.params.deviceId)} save={this.saveEntity} />
				</Content>
			</>
	}
}

export default DeviceEdit;
